module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup-picker', {
    attrs: {
      "show": _vm.showPickerPerson,
      "show-cell": false,
      "mainTitle": "选择乘车人数",
      "data": _vm.personList,
      "confirm-text": "确认"
    },
    on: {
      "on-hide": function($event) {
        _vm.showPickerPerson = false
      }
    },
    model: {
      value: (_vm.jspickerPerson),
      callback: function($$v) {
        _vm.jspickerPerson = $$v
      },
      expression: "jspickerPerson"
    }
  }), _vm._v(" "), _c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectPerson($event)
      }
    }
  }, [_c('span', {
    staticClass: "cell-lable-right",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-ren-"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cell-fontSize",
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.jsPerson) + "人")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1140274f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/personPick.vue
// module id = 382
// module chunks = 1